module.exports = __webpack_public_path__ + "img/hongJiTang_banner2.7cedbeab.png";